const routes = {
  getVehicleBookingFilter: 'vehicleBookings/filters',
  getVehicleBookings: 'vehicleBookings',
  getVehicleBookingDetail: 'vehicleBookings/details',
  createVehicleBooking: 'vehicleBookings/add',
  updateVehicleBooking: 'vehicleBookings/edit',
  getMissingFields: 'vehicleBookings/missingValues',
  updateMissingFieldVehicleBooking: 'vehicleBookings/update',
  getApprovalList: 'vehicleBookings/approvals',
  getApprovalDetail: 'vehicleBookings/approvals/details',
  reviewApproval: 'vehicleBookings/approvals/review',
  getBookingCustomers: 'vehicleBookings/filters',
};

export default routes